export function getStatesFromLatLng( latLng ) {
	let returnValue = []
	const bounds = {
		wa: {
			name: 'Western Australia',
			tl: [ -13.039608, 111.827340 ],
			br: [ -35.427321, 129.007769 ]
		},
		nt: {
			name: 'Northern Territory',
			tl: [ -9.630339, 129.007769 ],
			br: [ -25.999520, 137.998646 ]
		},
		sa: {
			name: 'South Australia',
			tl: [ -25.999350, 129.002766 ],
			br: [ -38.074052, 140.965534 ]
		},
		vic: {
			name: 'Victoria',
			tl: [ -33.980724, 140.963731 ],
			br: [ -39.268919, 150.218688 ]
		},
		tas: {
			name: 'Tasmania',
			tl: [ -39.305733, 143.464575 ],
			br: [ -43.959531, 149.231731 ]
		},
		nsw: {
			name: 'New South Wales',
			tl: [ -28.100595, 140.990296 ],
			br: [ -37.835730, 154.236919 ]
		},
		act: {
			name: 'ACT',
			tl: [ -35.121825, 148.758893 ],
			br: [ -35.927702, 149.387786 ]
		},
		qld: {
			name: 'Queensland',
			tl: [ -9.548258, 138.018910 ],
			br: [ -28.914867, 154.499033 ]
		},
	}

	Object.keys( bounds ).map( key => {
		let item = bounds[ key ]

		if (
			latLng.lat <= item.tl[0] &&
			latLng.lng >= item.tl[1] &&
			latLng.lat >= item.br[0] &&
			latLng.lng <= item.br[1]
		) {
			returnValue.push( {
				id: key,
				name: item.name
			} )
		}
	} )

	return returnValue
}



// WEBPACK FOOTER //
// ./utilities/map-aus.jsx